import React, { useState, useEffect, useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import EdModal from "../../generic/edModal";

export const FileUploadSection = (props: any) => {
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [fileTypeUploadError, setFileTypeUploadError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [fileTypeError, setFileTypeError] = useState(false);
  const [fileNameError, setFileNameError] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [fileSize, setFileSize] = useState(1048576);
  const [docFile, setDocFile] = useState("");
  const [fileData, setFileData] = useState("");
  const [cropData, setCropData] = useState("#");
  const [cropper, setCropper] = useState<any>();

  useEffect(() => {
    if (props.dropValChanged) {
      resetForm();
    }
  }, [props.dropValChanged]);
  useEffect(() => {
    if (props.fileSize) {
      setFileSize(props.fileSize);
    }
  }, [props.fileSize]);
  useEffect(() => {
    if (props.fileName) {
      setDocUploaded(true);
      setDocFile(props.fileName);
    }
  }, []);

  const resetForm = () => {
    setDocUploaded(false);
    setDocFile("");
    setFileError(false);
    setDocUploadError(false);
    setFileTypeError(false);
    setFileNameError(false);
    setFileTypeUploadError(false);
  };
  const onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    uploadFile(e.target.files![0]);
  };
  const uploadFile = (file: File) => {
    resetForm();
    const regex = /^[a-zA-Z0-9-_ ]*$/;
    if (file && file.name.split(".").length === 2) {
      var extensions = file.name.split(".");
      if(!props.fileType.find((val: any) => extensions[1].toLowerCase() === val)){
        setFileTypeError(true);
        return;
      }
      if(!(regex.test(extensions[0]))){
        setFileNameError(true);
        return;
      }
    }

    if (
      file.size > fileSize ||
      !props.fileType.find((val: any) => file.type.split("/")[1] === val)
    ) {
      setDocUploadError(true);
      // if file size is more than 1MB:
      if (!fileError) setFileError(true);
      return;
    }

    if (fileError) setFileError(false);
    if (props.secondFileName) {
      if (!props.secondFileName.split(".")[1].match(file.name.split(".")[1])) {
        setFileTypeUploadError(true);
        return;
      }
    }
    setDocFile(file.name);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setDocUploaded(true);
      if (
        props.crop &&
        (file.type === "image/jpeg" || file.type === "image/jpg")
      ) {
        setFileData(reader.result as string);
        setShowModal(true);
      } else {
        props.onSubmit({
          base64Data: reader.result as string,
          docFile: file.name,
        });
      }
    };

    reader.onerror = () => {
      setDocUploadError(true);
    };
  };

  const removeUplFile = () => {
    if (docFile) {
      props.onSubmit({
        base64Data: "",
        docFile: "",
      });
    }
    resetForm();
  };

  const dropHandler = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault();

    if (e.dataTransfer.items) {
      for (let i = 0; i < e.dataTransfer.items.length; i++) {
        if (e.dataTransfer.items[i].kind === "file") {
          uploadFile(e.dataTransfer.items[i].getAsFile()!);
        }
      }
    }
  };
  const cropperRef = useRef<HTMLImageElement>(null);
  const onCrop = () => {
    const imageElement: any = cropperRef?.current;
    const cropper: any = imageElement?.cropper;
   // console.log(cropper.getCroppedCanvas().toDataURL());
  };

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      setCropData(cropper.getCroppedCanvas().toDataURL());

      props.onSubmit({
        base64Data: cropper.getCroppedCanvas().toDataURL(),
        docFile: docFile,
      });
      setShowModal(false);
    }
  };
  const cropperModal = () => {
    return (
      <>
        <>
          <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup accntUploadPopup">
            <div className="modal-content">
              <div className="modal-body scrollableModal" id="custom_scrollBar">
                <div className="finalScreen consentPopup pinError">
                  <div className="positionFixed">
                    <div className="space-between-aligned">
                      <div>
                        <p>Sign.jpeg</p>
                      </div>
                      <ul className="display-flex editIcons">
                        <li>
                          <a
                            role="button"
                            onClick={() => {
                              const imageElement: any = cropperRef?.current;
                              const cropper: any = imageElement?.cropper;
                              cropper.zoom(0.1);
                            }}
                          >
                            <i className="edel-icon-zoomin"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            role="button"
                            onClick={() => {
                              const imageElement: any = cropperRef?.current;
                              const cropper: any = imageElement?.cropper;
                              cropper.zoom(-0.1);
                            }}
                          >
                            <i className="edel-icon-zoomout"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            role="button"
                            onClick={() => {
                              const imageElement: any = cropperRef?.current;
                              const cropper: any = imageElement?.cropper;
                              cropper.rotate(45);
                            }}
                          >
                            <i className="edel-icon-rotate"></i>
                          </a>
                        </li>
                      </ul>
                      <div>
                        <a
                          role="button"
                          onClick={() => {
                            removeUplFile();
                            setShowModal(false);
                          }}
                          title="Close"
                          className="cancel sign-cross-button"
                        >
                          <i className="edel-icon-close"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <Cropper
                    className="cropImageBg"
                    src={fileData}
                    style={{ height: 400, width: "100%" }}
                    preview=".img-preview"
                    // Cropper.js options
                    initialAspectRatio={16 / 9}
                    guides={true}
                    crop={onCrop}
                    ref={cropperRef}
                    viewMode={1}
                    restore={true}
                    // zoomOnWheel={false}
                    checkCrossOrigin={false}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                    onInitialized={(instance) => {
                      setCropper(instance);
                    }}
                  />
                </div>
                <div className="button">
                  <button
                    type="button"
                    style={{ float: "right" }}
                    onClick={getCropData}
                    className="ed_button primary button submit_btn"
                  >
                    Upload
                  </button>
                </div>
                <br style={{ clear: "both" }} />
              </div>
            </div>
          </div>
        </>
      </>
    );
  };

  return (
    <>
      {!docUploaded && (
        <label
          className="uploadWrap cursor uploadWrapBank"
          onDrop={dropHandler}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={(e) => e.preventDefault()}
        >
          <input
            type="file"
            onChange={onSelectFile}
            // accept={props.fileType[0] === "pdf" ? "application/pdf":""}
            className="display-none"
            onClick={(e) => ((e.target as HTMLInputElement).value = "")}
          />
          <div className="upload">
            <p>Drag and drop your document or</p>
            <p>
              <span className="bold-text">Click Here </span>
              to browse
            </p>
            <p className="light-text">
              {"." + props.fileType.join(", .")} (Max Size {fileSize/1048576}MB)
            </p>
          </div>
        </label>
      )}
      {docUploadError && (
        <div>
          <p className="uploadWarning error-msg">
            Document size exceeds maximum limit of {fileSize/1048576}MB. Please upload it again!
          </p>
        </div>
      )}
      {fileTypeUploadError && (
        <div>
          <p className="error-msg">
            The uploaded files types are not matching. Please upload same types
            of files!
          </p>
        </div>
      )}
      {fileTypeError && (
        <div>
          <p className="uploadWarning error-msg">
            Please upload only {"." + props.fileType.join(", .")} document!
          </p>
        </div>
      )}
      {fileNameError && (
        <div>
          <p className="uploadWarning error-msg">
          File names can contain alphanumeric characters and only the special characters hyphen (-) and underscore (_). Please update the file name and upload it again.
          </p>
        </div>
      )}
      {docFile && (
        <div className="uploadSectionWrap">
          <div className="custom--row">
            <div className="custom-col">
              <div className="align-center display-flex content-space-between">
                <div className="incomeProof__img">
                  <div className="align-center display-flex">
                    <div className="smallText">
                      <p>{docFile}</p>
                    </div>
                  </div>
                </div>
                <div className={props.disableCross ? "disabled" : "hover"}>
                  <span
                    role="button"
                    title="Close"
                    className="cancel"
                    onClick={removeUplFile}
                  >
                    <i className="edel-icon-close"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <EdModal
        show={showModal}
        close={() => {}}
        children={cropperModal()}
        // modalClsNm={"absoluteModal"}
      />
    </>
  );
};
